// try 4 new
// import React from "react";
// import { useFirebase } from "../providers/firebase";

// const ResearchDomainsPage = () => {
//     const { researchDomains, researchDomainsKeys } = useFirebase();

//     return (
//         <div className="researchDomains-page-container">
//             <div className="researchDomains-heading">Research Domains</div>
//             {researchDomains ? (
//                 <div>
//                     {researchDomainsKeys.map((key, index) => {
//                         const project = researchDomains.find(domain => domain.title === key);

//                         if (project) {
//                             return (
//                                 <div key={index} className="researchDomain-item">
//                                     <div className="researchDomain-media">
//                                         {/* Render media depending on mediatype */}
//                                         {project.mediatype === "video" && project.mediaurl.length > 0 ? (
//                                             <div className="video-gallery">
//                                                 {project.mediaurl.map((videoURL, videoIndex) => (
//                                                     <div key={videoIndex} className="video-card">
//                                                         <iframe
//                                                             width="100%"
//                                                             height="50"
//                                                             src={videoURL}
//                                                             title={`Video ${videoIndex + 1} - ${project.title}`}
//                                                             frameBorder="0"
//                                                             allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" 
//                                                             sandbox="allow-same-origin allow-scripts allow-presentation" 
//                                                             allowFullScreen
//                                                         ></iframe>
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         ) : project.mediatype === "video" ? (
//                                             <p>No video media available for {project.title}.</p>
//                                         ) : null}

//                                         {project.mediatype === "image" && project.mediaurl.length > 0 ? (
//                                             <div className="image-gallery">
//                                                 {project.mediaurl.map((imageURL, imageIndex) => (
//                                                     <div key={imageIndex} className="image-card">
//                                                         <img
//                                                             src={imageURL}
//                                                             alt={`Image ${imageIndex + 1} - ${project.title}`}
//                                                             style={{ width: '100%', height: 'auto' }}
//                                                         />
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         ) : project.mediatype === "image" ? (
//                                             <p>No image media available for {project.title}.</p>
//                                         ) : null}

//                                         {project.mediatype === "gif" && project.mediaurl.length > 0 ? (
//                                             <div className="gif-gallery">
//                                                 {project.mediaurl.map((gifURL, gifIndex) => (
//                                                     <div key={gifIndex} className="gif-card">
//                                                         <img
//                                                             src={gifURL}
//                                                             alt={`GIF ${gifIndex + 1} - ${project.title}`}
//                                                             style={{ width: '100%', height: 'auto' }}
//                                                         />
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         ) : project.mediatype === "gif" ? (
//                                             <p>No GIF media available for {project.title}.</p>
//                                         ) : null}
//                                     </div>

//                                     <div className="researchDomain-content">
//                                         <h1 className="researchDomain-title">{project.title}</h1>
//                                         {Array.isArray(project.description) && project.description.length > 0 ? (
//                                             <>
//                                                 <p className="researchDomain-description">
//                                                     {project.description[0]} {/* Main description */}
//                                                 </p>
//                                                 <ol className="researchDomain-pointers">
//                                                     {project.description.slice(1).map((pointer, idx) => (
//                                                         <li key={idx} className="pointer-item">{pointer}</li>
//                                                     ))}
//                                                 </ol>
//                                             </>
//                                         ) : (
//                                             <p>No description available.</p>
//                                         )}
//                                     </div>
//                                 </div>
//                             );
//                         }

//                         return null; 
//                     })}
//                 </div>
//             ) : (
//                 <p>Loading Research domains...</p>
//             )}

//             <div className="ResearchDomain-copyright">
//                 &copy; All Rights Reserved by VISMA Lab, SECS, IIT Bhubaneswar, 2024
//             </div>
//         </div>
//     );
// };

// export default ResearchDomainsPage;

// =========================================================================================
// try5
import React from "react";
import { useFirebase } from "../providers/firebase";

const ResearchDomainsPage = () => {
    const { researchDomains, researchDomainsKeys } = useFirebase();

    return (
        <div className="researchDomains-page-container">
            <div className="researchDomains-heading">Research Domains</div>
            {researchDomains ? (
                <div>
                    {researchDomainsKeys.map((key, index) => {
                        const project = researchDomains.find(domain => domain.title === key);

                        if (project) {
                            return (
                                <div key={index} className="researchDomain-item">
                                    <div className="researchDomain-media">
                                        {/* Render media depending on mediatype */}
                                        {project.mediatype === "video" && Array.isArray(project.mediaurl) && project.mediaurl.length > 0 ? (
                                            <div className="video-gallery">
                                                {project.mediaurl.map((videoURL, videoIndex) => {
                                                    // Transform the URL to the embed format
                                                    let embedUrl;
                                                    if (videoURL.includes("watch?v=")) {
                                                        embedUrl = videoURL.replace("watch?v=", "embed/");
                                                    } else if (videoURL.includes("youtu.be/")) {
                                                        embedUrl = videoURL.replace("youtu.be/", "www.youtube.com/embed/");
                                                    } else {
                                                        embedUrl = videoURL; // Fallback for other formats
                                                    }

                                                    return (
                                                        <div key={videoIndex} className="video-card">
                                                            <iframe
                                                                src={embedUrl}
                                                                width='100%'
                                                                title={`Video ${videoIndex + 1} - ${project.title}`}
                                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
                                                                allowFullScreen
                                                            ></iframe>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        ) : project.mediatype === "video" ? (
                                            <p>No video media available for {project.title}.</p>
                                        ) : null}

                                        {project.mediatype === "image" && Array.isArray(project.mediaurl) && project.mediaurl.length > 0 ? (
                                            <div className="image-gallery">
                                                {project.mediaurl.map((imageURL, imageIndex) => (
                                                    <div key={imageIndex} className="image-card">
                                                        <img
                                                            src={imageURL}
                                                            alt={`Image ${imageIndex + 1} - ${project.title}`}
                                                            style={{ width: '100%', height: 'auto' }}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        ) : project.mediatype === "image" ? (
                                            <p>No image media available for {project.title}.</p>
                                        ) : null}

                                        {project.mediatype === "gif" && Array.isArray(project.mediaurl) && project.mediaurl.length > 0 ? (
                                            <div className="gif-gallery">
                                                {project.mediaurl.map((gifURL, gifIndex) => (
                                                    <div key={gifIndex} className="gif-card">
                                                        <video
                                                            src={gifURL}
                                                            autoPlay
                                                            loop
                                                            muted
                                                            style={{ width: '100%', height: 'auto' }}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        ) : project.mediatype === "gif" ? (
                                            <p>No GIF media available for {project.title}.</p>
                                        ) : null}
                                    </div>

                                    <div className="researchDomain-content">
                                        <h1 className="researchDomain-title">{project.title}</h1>
                                        {Array.isArray(project.description) && project.description.length > 0 ? (
                                            <>
                                                <p className="researchDomain-description">
                                                    {project.description[0]} {/* Main description */}
                                                </p>
                                                <ol className="researchDomain-pointers">
                                                    {project.description.slice(1).map((pointer, idx) => (
                                                        <li key={idx} className="pointer-item">{pointer}</li>
                                                    ))}
                                                </ol>
                                            </>
                                        ) : (
                                            <p>No description available.</p>
                                        )}
                                    </div>
                                </div>
                            );
                        }

                        return null; 
                    })}
                </div>
            ) : (
                <p>Loading Research domains...</p>
            )}

            <div className="ResearchDomain-copyright">
                &copy; All Rights Reserved by VISMA Lab, SECS, IIT Bhubaneswar, 2024
            </div>
        </div>
    );
};
export default ResearchDomainsPage;